export const getDefaultAtlasBaseURL = isGlobalExperienceWorkspace => {
  const hostname = window.location.hostname;
  const subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
  if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) {
    return `https://${subdomain}.stg.atlassian.com`;
  }
  return `https://${subdomain}.atlassian.com`;
};
export const createGlobalExperienceLink = (entityId, path, isGlobalExperienceWorkspace, orgId) => {
  const baseUrl = getDefaultAtlasBaseURL(isGlobalExperienceWorkspace);
  if (isGlobalExperienceWorkspace && orgId) {
    return `${baseUrl}/o/${orgId}/${path}/${entityId}`;
  }
  return `${baseUrl}/${path}/${entityId}`;
};
export const createProfileLink = (accountId, isGlobalExperienceWorkspace, orgId) => createGlobalExperienceLink(accountId, 'people', isGlobalExperienceWorkspace, orgId);
export const createTeamProfileLink = (teamId, isGlobalExperienceWorkspace, orgId) => createGlobalExperienceLink(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
const getAtlasViewAllRedirectUrl = (entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId) => {
  let url;
  if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) {
    url = new URL(workspaces[0].baseUrl);
  } else {
    url = new URL(getDefaultAtlasBaseURL(isGlobalExperienceWorkspace));
  }
  const pathPrefix = isGlobalExperienceWorkspace && orgId ? `o/${orgId}/` : '';
  url.pathname = `${pathPrefix}action/search/${entity}`;
  url.searchParams.append('searchText', searchText);
  return url.href;
};
export default getAtlasViewAllRedirectUrl;